export enum SprintCategoryNames {
    low = "low",
    medium = "medium",
    high = "high",
}
